import CenteredSpinner from './CenteredSpinner';

export default CenteredSpinner;



// WEBPACK FOOTER //
// ./src/components/Utility/CenteredSpinner/index.js